const home = {
  hero: {
    eyebrow: "Gujarat Pharma Union",
    line1: "United for a safer,",
    line2: "stronger pharma",
    line3: "trade",
    sub: "Gujarat Pharma Union brings licensed pharmaceutical traders together on one trusted platform focused on compliance, genuine medicines, fair trade and collective protection.",
    scroll: "Scroll to explore",
    badge: "Licensed Trade • Verified Network • Gujarat",
  },
  marquee: [
    "Unity",
    "Compliance",
    "Protection",
    "Genuine Medicines",
    "Fair Trade",
    "Traceability",
    "Patient Safety",
    "Verified Vendors",
    "Due Diligence",
    "Responsible Reporting",
  ],
  counters: {
    title: "The organisation at a glance",
    note: "All figures are maintained by the GPU secretariat and will be published only after official verification. No estimated or illustrative numbers are shown.",
    members: "Verified Members",
    vendors: "Verified Vendors",
    districts: "Districts Covered",
    committee: "Committee Members",
    support: "Support Requests Resolved",
  },
  why: {
    eyebrow: "Why GPU",
    title: "Why Gujarat Pharma Union?",
    sub: "Six structural reasons a licensed pharmaceutical trader in Gujarat benefits from an organised, compliance-first collective.",
    cards: [
      {
        n: "01",
        icon: "users",
        title: "Strong Unity",
        body: "One collective voice for licensed pharmaceutical traders across Gujarat.",
      },
      {
        n: "02",
        icon: "shield-check",
        title: "Compliance First",
        body: "Promote lawful, documented and responsible pharmaceutical trade at every level.",
      },
      {
        n: "03",
        icon: "network",
        title: "Safe Vendor Network",
        body: "Help Members identify verified business counterparties before trade begins.",
      },
      {
        n: "04",
        icon: "scale",
        title: "Member Protection",
        body: "Structured support during regulatory, legal and commercial challenges.",
      },
      {
        n: "05",
        icon: "search-check",
        title: "Anti-Counterfeit Awareness",
        body: "Encourage traceability, supplier verification and responsible reporting.",
      },
      {
        n: "06",
        icon: "landmark",
        title: "Strong Representation",
        body: "Represent legitimate trade concerns before appropriate authorities and industry bodies.",
      },
    ],
  },
  principle: {
    eyebrow: "Our Principle",
    title: "Protect the Patient. Identify the Actual Wrongdoer. Protect the Genuine Pharmaceutical Supply Chain.",
    body: "GPU supports strict lawful action against those knowingly involved in counterfeit, spurious, adulterated or illegal medicines, while also supporting fair treatment, due process and protection of compliant licensed traders.",
    chapters: [
      { n: "I", title: "Patient First", body: "Every position GPU takes begins with the safety of the person who consumes the medicine." },
      { n: "II", title: "Accountability", body: "Those knowingly dealing in illegal medicines must face the full force of law." },
      { n: "III", title: "Due Process", body: "Compliant businesses deserve evidence-based determination before conclusions are drawn." },
    ],
  },
  compare: {
    eyebrow: "Choose your track",
    title: "Member or Vendor",
    sub: "Two distinct tracks, one verified ecosystem.",
    member: {
      label: "GPU Member",
      for: "For eligible Gujarat-based licensed pharmaceutical traders.",
      benefits: [
        "Verified GPU identity",
        "Member network",
        "Safe Vendor access",
        "Compliance support",
        "Legal support",
        "Regulatory updates",
        "Training",
        "Committee support",
        "Representation",
      ],
    },
    vendor: {
      label: "GPU Vendor",
      for: "For eligible suppliers serving GPU Members.",
      benefits: [
        "Verified Vendor profile",
        "Gujarat trade network visibility",
        "Compliance identity",
        "Digital agreements",
        "Vendor support",
        "Member discovery",
        "Structured trade relationships",
      ],
    },
  },
  memberSteps: {
    eyebrow: "Membership journey",
    title: "Become a Verified GPU Member",
    steps: [
      "Register Mobile & Email",
      "Submit Business Details",
      "GST & Drug Licence Verification",
      "Complete KYC & Documents",
      "eSign GPU Agreements & Pay Membership Fee",
      "Receive GPU Verified Member ID",
    ],
    disclaimer:
      "Membership approval is subject to eligibility, document verification, applicable fees, agreements and GPU approval.",
  },
  vendorSteps: {
    eyebrow: "Vendor journey",
    title: "Become a GPU Verified Vendor",
    steps: [
      "Create Vendor Account",
      "Submit GST & Drug Licence",
      "Business & Compliance Verification",
      "Submit Required Authorizations",
      "eSign Vendor Declarations & Agreements",
      "Receive GPU Verified Vendor Status",
    ],
    disclaimer:
      "Vendor verification indicates completion of GPU's applicable credential and compliance review process and is not a guarantee of individual products, transactions or commercial performance.",
  },
  shield: {
    eyebrow: "GPU Shield",
    title: "GPU Shield — Member Protection",
    sub: "Structured, responsible and lawful support for compliant Members.",
    items: [
      { icon: "gavel", title: "Legal Support", body: "Structured support during inspections, notices, sampling, regulatory matters and other eligible issues." },
      { icon: "file-check", title: "Compliance Assistance", body: "Support with documents, licences and verification." },
      { icon: "archive", title: "Evidence Preservation", body: "Secure recordkeeping for supplier and trade evidence." },
      { icon: "book-open", title: "Regulatory Guidance", body: "Updates, circulars and compliance awareness." },
      { icon: "megaphone", title: "Reputation Support", body: "Responsible assistance for eligible trade-related reputation issues." },
    ],
    note: "GPU does not obstruct lawful inspection, investigation or regulatory action.",
  },
  safeTrade: {
    eyebrow: "Safe Trade Network",
    title: "Trade with greater confidence",
    body: "GPU Safe Trade Network helps Members identify Vendors whose declared business credentials have been reviewed according to GPU verification policy.",
    cards: ["GST Verified", "Drug Licence Checked", "Agreement Completed", "Compliance Status", "Verification Date", "Digital Vendor ID"],
    disclaimer:
      "GPU verification relates to business credentials and compliance status. It is not a guarantee regarding authenticity or quality of every medicine or batch supplied.",
  },
  antiCounterfeit: {
    eyebrow: "Our position",
    title: "Zero tolerance for knowingly illegal medicine trade",
    body: "GPU strongly supports strict lawful action against any person knowingly involved in counterfeit, spurious, adulterated or illegal pharmaceutical trade.",
    fairness:
      "GPU supports evidence-based investigation, scientific verification, fair process and responsible public communication so that legitimate businesses are not prematurely judged without proper determination.",
    discipline: [
      "Verify Supplier",
      "Check Licence",
      "Maintain Invoice",
      "Record Batch",
      "Preserve Payment Trail",
      "Report Suspicion",
      "Hold & Verify",
      "Cooperate Lawfully",
    ],
  },
  benefits: {
    eyebrow: "Member benefits",
    title: "What membership actually gives you",
    items: [
      { title: "GPU Verified Digital Identity", live: true },
      { title: "Digital Member ID Card", live: true },
      { title: "Safe Vendor Network", live: true },
      { title: "Compliance Passport", live: false },
      { title: "Legal & Regulatory Support", live: true },
      { title: "Regulatory Updates", live: true },
      { title: "Committee Support", live: true },
      { title: "Training & Certification", live: false },
      { title: "Secure Document Records", live: true },
      { title: "Member Networking", live: true },
      { title: "Trade Representation", live: true },
      { title: "GPU Support Line", live: true },
      { title: "Future Safe Trade Tools", live: false },
    ],
  },
  committee: {
    eyebrow: "Leadership",
    title: "Leadership you can reach",
    sub: "Committee profiles are published by the GPU secretariat after formal approval.",
  },
  updates: {
    eyebrow: "Newsroom",
    title: "Latest from GPU",
    sub: "Regulatory updates, official communications and events.",
  },
  resourcePreview: {
    eyebrow: "Knowledge Center",
    title: "Stay informed. Stay compliant.",
    sub: "Acts, rules, circulars, SOPs and compliance guides in one organised library.",
  },
  verify: {
    eyebrow: "Public verification",
    title: "Verify before you trust",
    sub: "Check a GPU Member Code or GPU Vendor Code before beginning trade.",
  },
  finalCta: {
    title: "Join a stronger pharmaceutical community",
    sub: "Build trust. Stay compliant. Trade responsibly. Stand united.",
  },
};

export default home;
